import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "@ag-grid-community/angular";

@Component({
  selector: "app-actions-cell",
  template: `<div id="detailedsiteList" title="{{ params.value }}">
    <a
      (click)="opennewtab()"
      style="text-decoration:none;overflow:hidden;text-overflow:ellipsis;color: #007bff;cursor:pointer"
      >{{ params.value }}</a
    >
  </div>`,
  styles: [],
})
export class DetailedSiteListRendererComponent
  implements ICellRendererAngularComp
{
  public params: any;
  public colors = "";
  public sid = "";
  public link = "";
  agInit(params: any): void {
    this.params = params;
    this.sid = this.params.data.SiteID;
    let siteCode = this.params.data.siteCode;
    let siteName = this.params.data.sitename;

    let url = this.params.colDef.customParam;
    this.link = !url ? "#/siteDetails" : `#/${url}`;
    const str = JSON.stringify({
      siteID: this.sid,
      siteCode: siteCode,
      siteName: siteName,
    });

    const encr = window.btoa(str);
    this.link = this.link + "?e=" + encr;
  }
  refresh(): boolean {
    return false;
  }
  opennewtab() {
    window.open(this.link);
  }
}
